import type { Metadata } from "next";
import AdminPlan from "@/Component/Admin/AdminPlan"

export const metadata: Metadata = {
    title: "Plans | Connector Club",
    description: "",
};

const AdminPlanPage = () => {
  return (
    <AdminPlan />
  )
}

export default AdminPlanPage
